function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
  } catch (e) {
    return "";
  }
}

export default function PostCard({ post, compact = false }) {
  const body = compact && post.body && post.body.length > 180 ? `${post.body.slice(0, 180).trim()}…` : post.body;
  return (
    <article className="border border-white/12 hover:border-white/30 transition-colors flex flex-col h-full" data-testid={`post-card-${post.id}`}>
      {post.image && (
        <div className="aspect-[16/10] overflow-hidden bg-white/[0.02]">
          <img src={post.image} alt={post.title} className="w-full h-full object-cover" loading="lazy" />
        </div>
      )}
      <div className="p-7 flex-1 flex flex-col">
        <p className="overline text-white/45">{formatDate(post.created_at)}</p>
        <p className="font-serif text-white text-2xl font-light mt-3 leading-snug">{post.title}</p>
        <p className="text-white/70 font-light text-sm mt-4 leading-relaxed whitespace-pre-line">{body}</p>
      </div>
    </article>
  );
}
